import { Text } from '@chakra-ui/react'
import { SolidActionButton } from '@components/Buttons'
import { DefaultModal } from '@components/Modals'
import {
  useDotPhraseExpansion,
  UseDotPhraseExpansion,
} from '@hooks/backend/dotPhrase/useDotPhraseExpansion'
import React, { createContext, useContext } from 'react'

export const DotPhraseContext = createContext<UseDotPhraseExpansion | null>(null)

export const useDotPhrase = () => useContext(DotPhraseContext)

export const DotPhraseProvider = ({
  practiceId,
  children,
}: {
  practiceId: string | null | undefined
  children: React.ReactNode
}) => {
  const value = useDotPhraseExpansion(practiceId)
  return (
    <DotPhraseContext.Provider value={value}>
      {children}
      {value.showNotice && (
        <DefaultModal
          isOpen
          onClose={value.dismissNotice}
          header="Template inserted"
          render={() => (
            <Text p={4} fontSize="sm">
              Template text inserted — review and edit to accurately reflect this encounter before
              authenticating.
            </Text>
          )}
          renderFooter={({ onClose }) => (
            <SolidActionButton onClick={onClose} m={4}>
              Got it
            </SolidActionButton>
          )}
        />
      )}
    </DotPhraseContext.Provider>
  )
}
